import Vue from "vue";
import axios from "axios";
import Cookies from "js-cookie";

function isTokenInvalidError(error) {
  const { message } = error.response.data;
  return message === "jwt expired";
}

function responseSuccessHandler(response) {
  return response.data;
}

function responseErrorHandler(error) {
  if (isTokenInvalidError(error)) {
    alert("登入時間過長或錯誤的token，請重新登入");
    API.defaults.headers.common["x-access-token"] = undefined;
    Cookies.remove("user");
    Cookies.remove("GladName");
    Cookies.remove("GladPermission");
    Cookies.remove("GladTeamCode");
    Cookies.remove("GladAccount");
    Cookies.remove("GladCompanyServicePhone");
    Cookies.remove("GladArea");
    Cookies.remove("GladAddressGps");
    Cookies.remove("Flag");
    location.hash = "#/login";
  } else if (error.response.status >= 500) {
    alert("伺服器發生錯誤，請聯絡管理人員");
  }
  return Promise.reject(error.response);
}

function getBaseUrl() {
  var baseUrl = "";
  if (location.href.includes("localhost")) {
    baseUrl = "https://staging.ap.gladmobile.com/";
  } else if (location.href.includes("staging.backstage.gladmobile.com")) {
    baseUrl = "https://staging.ap.gladmobile.com/";
  } else if (location.href.includes("daisuki.backstage.gladmobile.com")) {
    baseUrl = "https://test-fleet.gladmobile.com/";
  } else if (location.href.includes("staging-2.backstage.gladmobile.com")) {
    baseUrl = "https://staging2.ap.gladmobile.com/";
  } else if (location.href.includes("backstage.gladmobile.com")) {
    baseUrl = "https://test-fleet.gladmobile.com/";
  } else {
    baseUrl = "https://" + window.location.hostname + "/";
  }
  return baseUrl;
}
function getAPIUrl() {
  return getBaseUrl() + "web/api/";
}


const API = axios.create({
  baseURL: getAPIUrl(),
  timeout: 1000 * 6
});

API.defaults.headers.common['x-access-token'] = Cookies.getJSON('token');
API.interceptors.response.use(responseSuccessHandler, responseErrorHandler);

API.getBaseUrl = getBaseUrl();
API.getAPIUrl = getAPIUrl();
export default API;



// WEBPACK FOOTER //
// ./src/asset/js/TeamAPI.js